__turbopack_context__.v({
  "content": "SykmeldtSide-module__yNwpPq__content",
  "innercontent": "SykmeldtSide-module__yNwpPq__innercontent",
});
